// extracted by mini-css-extract-plugin
var _1 = "32px";
var _2 = "86px";
var _3 = "288px";
var _4 = "246px";
var _5 = "422px";
var _6 = "1166px";
var _7 = "250px";
var _8 = "802px";
var _9 = "28px";
var _a = "188px";
export { _1 as "innerRightContentPadding", _2 as "magneticWallCollapsedWidth", _3 as "magneticWallMaxWidth", _4 as "magneticWallMinWidth", _5 as "magneticWallWideWidth", _6 as "sidebarShiftBreakpoint", _7 as "sidebarWidth", _8 as "staticAreasWidth", _9 as "tocCollapsedWidth", _a as "tocMinWidth" }
